export default __webpack_public_path__ + "static/media/more.8e623a51.svg";